module.exports = __webpack_public_path__ + "img/vipgif.682bef81.gif";